import {
  hraInputQuestionnaireLoadBegin,
  hraInputQuestionnaireLoadSuccess,
  hraInputQuestionnaireLoadFailed,
  hraInputQuestionnaireSelectBodyPartFront,
  hraInputQuestionnaireSelectBodyPartBack,
  hraInputQuestionnaireDeselectBodyPartFront,
  hraInputQuestionnaireDeselectBodyPartBack,
} from "../actions/hraInputQuestionnaireActions";

const initialState = {
  questionsInfo: {},
  frontBodyParts: [],
  backBodyParts: [],
  fetching: false,
  fetched: false,
  error: null,
  sectionValidationError: { msgId: null },
};

const trimItems = items => {
  if (items && items.length > 0) {
    const temp = [];
    items.forEach(i => temp.push(i.trim()));
    return temp;
  }
  return items;
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case hraInputQuestionnaireLoadBegin:
      return { ...state, fetching: true };
    case hraInputQuestionnaireLoadFailed:
      return { ...state, fetching: false, error: action.payload };
    case hraInputQuestionnaireLoadSuccess: {
      let answeresForBodyPartQuestion = null;
      try {
        answeresForBodyPartQuestion = action.payload.sections
          .filter(sec => sec.sectionTag === "musculoskeletal")[0]
          .subsections.filter(subsec => subsec.subsectionTag === "musculoskeletal")[0]
          .questions.filter(q => q.tag === "musculoskeletal_parts")[0].response;
      } catch (ex) {
        console.log(
          `Error in reading the answers for Body Parts Selection question.\nError: ${ex}`
        );
      }
      const bodyPartsAnswers = answeresForBodyPartQuestion
        ? JSON.parse(answeresForBodyPartQuestion.optionText)
        : {};
      const frontBodyParts = bodyPartsAnswers.front ? trimItems(bodyPartsAnswers.front) : [];
      const backBodyParts = bodyPartsAnswers.back ? trimItems(bodyPartsAnswers.back) : [];

      return {
        ...state,
        fetching: false,
        fetched: true,
        questionsInfo: action.payload,
        frontBodyParts,
        backBodyParts,
      };
    }
    case hraInputQuestionnaireSelectBodyPartFront:
      return {
        ...state,
        frontBodyParts: [...state.frontBodyParts, action.payload],
      };
    case hraInputQuestionnaireSelectBodyPartBack:
      return {
        ...state,
        backBodyParts: [...state.backBodyParts, action.payload],
      };
    case hraInputQuestionnaireDeselectBodyPartFront:
      return {
        ...state,
        frontBodyParts: state.frontBodyParts.filter(bp => bp != action.payload),
      };
    case hraInputQuestionnaireDeselectBodyPartBack:
      return {
        ...state,
        backBodyParts: state.backBodyParts.filter(bp => bp != action.payload),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/hraInputQuestionnaireReducer.jsx